// extracted by mini-css-extract-plugin
export default {"heading":"bs-z","corrected":"cs-z","redirectVerbiageContainer":"ds-z","redirectVerbiageText":"es-z"};